import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      cacheTime: 60000,
      staleTime: 60000,
    },
    mutations: {
      retry: false,
    },
  },
});

export enum QueryKeys {
  ACTIVE_PASSES = 'ACTIVE_PASSES',
  ACTIVITY_FEED_SITE_OPTIONS = 'ACTIVITY_FEED_SITE_OPTIONS',
  ADMIN_SITES = 'ADMIN_SITES',
  ASSET_HISTORY = 'ASSET_HISTORY',
  ASSET_TYPES = 'ASSET_TYPES',
  ASSETS = 'ASSETS',
  COMPANY_LOGO = 'COMPANY_LOGO',
  INACTIVE_PASSES = 'INACTIVE_PASSES',
  INVITATION_DETAILS = 'INVITATION_DETAILS',
  INVITATIONS = 'INVITATIONS',
  MY_HOST_PROFILES = 'MY_HOST_PROFILES',
  MY_SITES_WITH_PERMISSIONS = 'MY_SITES_WITH_PERMISSIONS',
  PARENT_SITE_OPTIONS = 'PARENT_SITE_OPTIONS',
  PARENT_VISITOR_TYPES = 'PARENT_VISITOR_TYPES',
  PARENT_VISITOR_TYPES_OPTIONS = 'PARENT_VISITOR_TYPES_OPTIONS',
  PASS_INFO = 'PASS_INFO',
  SITE_HISTORY = 'SITE_HISTORY',
  SITE_HOSTS = 'SITE_HOSTS',
  SITE_LOCATION = 'SITE_LOCATION',
  TEAM_FEATURES = 'TEAM_FEATURES',
  TEAM_METADATA = 'TEAM_METADATA',
  TEAMS_LIST = 'TEAMS_LIST',
  TRIAL_DATA = 'TRIAL_DATA',
  TUNNELS = 'TUNNELS',
  UPCOMING_PASSES = 'UPCOMING_PASSES',
  WORKFLOW_INFO = 'WORKFLOW_INFO',
  ZONE_HOSTGROUPS = 'ZONE_HOSTGROUPS',
  ZONES = 'ZONES',
  PRICES = 'PRICES',
}

/**
 * @description Invalidates all queries that fuzzy match the keys.
 */
export function invalidateQueryCaches(keys: Array<QueryKeys>) {
  queryClient
    .getQueryCache()
    .getAll()
    .forEach((cache) => {
      if (keys.find((key) => cache.queryHash.includes(key))) {
        // Fire and forget
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        queryClient.invalidateQueries(cache.queryKey);
      }
    });
}
